module.exports = __webpack_public_path__ + "static/media/success.9f16e833.png";